// extracted by mini-css-extract-plugin
export default {"paginationBox":"ecoduXj2xTcgh4KgJH0U","outBox":"oXAkKIZkLczKIjol48hD","inBox":"WgEO6EvlaqP3NcBXjeFn","info":"vLboAI0Pw8RHif1Fexvi","buttonList":"MyvibDopqeLXU1f3cDdQ"};